import React from 'react';
import * as actCustomerList from 'actions/customers/list';
import { connect } from 'react-redux';
import {
  doImportCustomer,
  showModalImport,
  showModalErrorImport,
} from 'actions/uploaders';
import NoDataAndLoading from 'components/NoDataAndLoading';
import withFeatureFlags from 'hocs/withFeatureFlags';
import List from './List';
import ActionBar from './ActionBar';
import ImportModal from './importModal';
import ImportModalError from './importModalError';
import styles from './CustomerList.css';
import CustomerDetail from './CustomerDetail';
import ImportingModeModal from './ImportingModeModal';

class CustomerList extends React.Component {
  render() {
    const {
      showModalImport,
      showModalErrorImport,
      messageError,
    } = this.props.data.uploaders.import;
    const { showLoadingButton } = this.props.data.buttons;
    const { showLoadingSpinnerPage } = this.props.data.loadingSpinner;
    const { customers } = this.props.data.customers.list;

    return (
      <div id="customer-list" className={styles.wrapper}>
        <ActionBar
          onClickImport={this._onClickImport}
          onClickExport={this._onClickExport}
          loyaltySubscription={this.props.loyaltySubscription}
          goToSubscribeView={this.props.goToSubscribeView}
        />
        <div className={`row ${styles['mk-customer-list']}`}>
          <div
            className={`col-sm-12 col-md-12 ${styles['left-column']}`}
            id="mk-col-left"
          >
            <NoDataAndLoading
              showLoadingSpinner={showLoadingSpinnerPage}
              noDataToDisplay={customers.length === 0}
              title="No Data To Display"
              description=""
              linkLabel="Import Your Existing Customer Database"
              linkUrl="https://mokaposhelp.zendesk.com/hc/id/articles/900000402243-Cara-Mengimpor-Data-Pelanggan-dari-Excel"
            />
            <List />
          </div>
          <div
            className={`col-sm-12 ${styles['right-column']}`}
            id="mk-col-right"
          >
            <CustomerDetail
              onClickDone={this._closeCustomerDetail}
              showPurchaseHistory={this.props.showPurchaseHistory}
            />
          </div>
        </div>
        <ImportModal
          onShow={showModalImport}
          onHide={this._onClickCancelImport}
          onUpload={this._onClickUploadButton}
          showLoadingButton={showLoadingButton}
          onClickDownloadTemplate={this._onClickDownloadTemplate}
          changeModalVisibility={this._changeModalVisibility}
        />
        <ImportModalError
          onShow={showModalErrorImport}
          messageError={messageError}
          onClickTryBtn={this._onClickTryBtn}
          onClickCancelBtnError={this._onClickCancelBtnError}
          onClickDownloadTemplate={this._onClickDownloadTemplate}
        />
        <ImportingModeModal />
      </div>
    );
  }

  _onClickTryBtn = () => {
    this.props.dispatch(showModalImport(true));
    this.props.dispatch(showModalErrorImport(false, []));
  };

  _onClickCancelBtnError = () => {
    this.props.dispatch(showModalImport(false));
    this.props.dispatch(showModalErrorImport(false, []));
  };

  _onClickExport = () => {
    const { enableCustomerExportTemplate, data } = this.props;

    if (enableCustomerExportTemplate) {
      this.props.dispatch(actCustomerList.downloadCustomerExportTemplate());
    } else {
      const userEmail = data.moka.user.email;
      const filename = `Customer List - ${userEmail}`;
      this.props.dispatch(actCustomerList.customerExportRequest(filename));
    }
  };

  _onClickImport = () => {
    this.props.dispatch(showModalImport(true));
  };

  _onClickCancelImport = () => {
    this.props.dispatch(showModalImport(false));
  };

  _onClickUploadButton = file => {
    this.props.dispatch(doImportCustomer(file));
  };

  _changeModalVisibility = () => {
    const { showModalImport } = this.props.data.uploaders.import;
    this.props.dispatch(
      actCustomerList.changeModalVisibility(!showModalImport)
    );
  };

  _closeCustomerDetail = () => {
    if ($('#customer-detail').is(':visible')) {
      this.props.dispatch(actCustomerList.closeCustomerDetail()); // back to list customers
    } else {
      // back to customer detail
      $('#receipt-invoice-customer').hide();
      $('#receipt-transaction-customer').hide();
      $('#customer-detail').show();
    }
  };

  _onClickDownloadTemplate = () => {
    const userEmail = this.props.data.moka.user.email;
    const filename = `Customer List - ${userEmail}`;
    this.props.dispatch(actCustomerList.downloadCustomerTemplate(filename));
  };
}

function mapStateToProps(state) {
  return {
    data: state,
  };
}

const mapFlagsToProps = flags => ({
  enableCustomerExportTemplate: flags.enableCustomerExportTemplate,
});

export default withFeatureFlags(mapFlagsToProps)(
  connect(mapStateToProps)(CustomerList)
);
